// student subscription has no native-store products yet.
export const GALATEA_STUDENT_SKU = 'glt-un-yr-student1';

const DEFAULT_SKU = 'gtl-un-yr';

export const skuByProductIdLookup: Record<string, string> & { defaultSku: string } = {
  // Subscription bundles
  defaultSku: DEFAULT_SKU,
  'com.colt.unlimited.yearly.baseline': 'gtl-un-yr',
  'com.colt.unlimited.yearly.baseline:p1y': 'gtl-un-yr',
  'com.colt.unlimited.1m_1y_baseline.p1y': 'glt-un-yr-1m1y',
  'com.colt.unlimited.1m_1y_baseline:p1y': 'glt-un-yr-1m1y',
  'com.colt.unlimited.1m_1y_lower1:p1y': 'glt-un-yr-1m1yl1',
  'com.colt.unlimited.1m_1y_lower1.p1y': 'glt-un-yr-1m1yl1',
  'com.colt.unlimited.indiv_intl.baseline:p1y': 'glt-un-yr-1',
  'com.colt.unlimited.indiv_intl.baseline.p1y': 'glt-un-yr-1',
  'com.colt.unlimited.intro_3m.baseline.p1m': 'glt-un-mo',
  'com.colt.unlimited.intro_3m.lower1.p1m': 'glt-un-mo-l1',
  'com.colt.unlimited.1m_1y_lower1.p1m': 'glt-un-mo-l1',
  'com.colt.unlimited.1m_1y_baseline:p1m-with-intro-offer': 'glt-un-mo',
  'com.colt.unlimited.1m_1y_lower1:p1m-with-intro-offer': 'glt-un-mo-l1',
  'com.colt.unlimited.with_intro_offer.individual.p1y': 'gtl-un-yr',

  // ads subscription test
  'com.colt.unlimited.no_ads.baseline.p1y': 'glt-un-yr-no_ads',
  'com.colt.unlimited.no_ads.baseline:p1y': 'glt-un-yr-no_ads',
  'com.colt.unlimited.ads.baseline.p1y': 'glt-un-yr-ads',
  'com.colt.unlimited.ads.baseline:p1y': 'glt-un-yr-ads',

  // north star monthly v2
  'com.colt.unlimited.1m_1y_v2.p1m': 'glt-un-mo-1m1y.v2',
  'com.colt.unlimited.1m_1y_v2:p1m': 'glt-un-mo-1m1y.v2',
  'com.colt.unlimited.1m_1y_v2.p1y': 'glt-un-yr-1m1y.v2',
  'com.colt.unlimited.1m_1y_v2:p1y': 'glt-un-yr-1m1y.v2',

  // international v2
  'com.colt.unlimited.indiv_intl.v2.p1y': 'gtl-un-yr-intl.v2',
  'com.colt.unlimited.indiv_intl.v2:p1y': 'gtl-un-yr-intl.v2',
  'com.colt.points.sm.international.v2': 'pp-intl.v2-40',
  'com.colt.points.md.international.v2': 'pp-intl.v2-110',
  'com.colt.points.lg.international.v2': 'pp-intl.v2-250',
  'com.colt.points.xl.international.v2': 'pp-intl.v2-550',

  // Points bundles
  'com.colt.app.tattoos.25': 'pp-110',
  'com.colt.app.tattoos.40': 'pp-250',
  'com.colt.app.points.bigger': 'pp-550',
  'com.colt.app.points.sm.golden.hour': 'pp-gh-40',
  'com.colt.points.xl.discounted': 'pp-upsell-550',

  // split test
  'com.colt.text.split_b.p1y': 'glt-t-yr-spb',
  'com.colt.audio.split_b.p1m': 'glt-a-yr-spb',
  'com.colt.u.split_b.p1y': 'glt-un-yr-spb',
  'com.colt.audio.yearly.split_b.p1y': 'glt-a-yr-spb-v2',
  // 3-month audio add-on, iOS identifier only — like its `split_b` neighbours above. The lookup is an
  // exact match and Saturn feeds it RevenueCat's `store_identifier`, which on Play carries the base
  // plan, so a `com.colt.audio.3month.split_b:<basePlanId>` key is needed before Android buyers can be
  // priced correctly; without one they fall through to the default yearly-unlimited SKU.
  'com.colt.audio.3month.split_b.p3m': 'glt-a-3m-spb',
  'com.colt.text.split_b.add_on.p1m': 'glt-t-m-spb',

  // points limited subscription test
  'com.colt.points.pls.p1y': 'glt-p-yr-pls',
  'com.colt.u.pls.p1y': 'glt-un-yr-pls',
  'com.colt.points.pls.v2.p1y': 'glt-p-yr-pls-v2',

  // weekly/yearly no wait timers test
  'com.colt.unlimited.1w_1y_lower1.p1y': 'glt-un-yr-1w1y.l1',
  'com.colt.unlimited.1w_1y_lower1:p1y': 'glt-un-yr-1w1y.l1',
  'com.colt.unlimited.1w_1y_lower1.p1w': 'glt-un-wk-1w1y.l1',
  'com.colt.unlimited.1w_1y_lower1:p1w': 'glt-un-wk-1w1y.l1',

  // harlequin
  'com.colt.harlequin.monthly.p1m': 'hlqn-1m-1',
  'com.colt.harlequin.higher1.monthly.p1m': 'hlqn-1m-2',
  // 3-month offer used by the post-purchase upsell. Like its monthly neighbours this covers the iOS
  // identifier only; a Play `<productId>:<basePlanId>` key has to be added once the base plan exists,
  // or Android lookups fall through to the default yearly-unlimited SKU.
  'com.colt.harlequin.3month.p3m': 'hlqn-3m-4',

  // harlequin & galatea
  'com.colt.text.hq_bundle.split_c.p1y': 'glt-th-yr',
  // The unlimited bundle carries no arm marker: it is offered from the split arm's audiobook entry
  // point and from non-split offerings alike. The Play key must match the base plan actually created.
  'com.colt.u.hq_bundle.p1y': 'glt-uh-yr',
  'com.colt.u.hq_bundle:p1y': 'glt-uh-yr',
  // the same bundle sold as the Points+ upgrade. A separate store product because that
  // upgrade only happens in place inside the Points+ subscription group, which the bundle above is
  // not in — the ids differ by the `pls` marker the other Points+ arm products carry.
  'com.colt.u.pls.hq_bundle.p1y': 'glt-uh-yr-pls',
  'com.colt.u.pls.hq_bundle:p1y': 'glt-uh-yr-pls',
  // Yearly Galatea + Harlequin bundle at $69.99 (30% off) for CRM A/B tests. The Play key must match the
  // base plan actually created.
  'com.colt.u_d.hq_bundle.p1y': 'glt-uh-yr-1',
  'com.colt.u_d.hq_bundle:p1y': 'glt-uh-yr-1',

  // galatea 7499 yearly unlimited subscription
  'com.colt.app.yearly.unlimited_v2.7499': 'glt-un-yr-7499.v2',

  'com.colt.unlimited.1m_1y_higher1.p1y': 'glt-un-yr-1m1y.h1',
  'com.colt.unlimited.1m_1y_higher1.p1m': 'glt-un-mo-1m1y.h1',

  'com.colt.unlimited.1m_1y_higher2.p1y': 'glt-un-yr-1m1y.h2',
  'com.colt.unlimited.1m_1y_higher2.p1m': 'glt-un-mo-1m1y.h2',
};

export const introductoryOfferSkuByProductIdLookup: Record<string, string> = {
  'com.colt.unlimited.intro_3m.baseline.p1m': 'glt-un-intro-3m',
  'com.colt.unlimited.intro_3m.baseline:p1m': 'glt-un-intro-3m',
  'com.colt.unlimited.intro_3m.lower1.p1m': 'glt-un-intro-3m',
  'com.colt.unlimited.intro_3m.lower1:p1m': 'glt-un-intro-3m',
  'com.colt.unlimited.1m_1y_baseline:p1m-with-intro-offer': 'glt-un-intro-3m',
  'com.colt.unlimited.1m_1y_lower1:p1m-with-intro-offer': 'glt-un-intro-3m',
};
